import builder from '../builder';
import CloseQuote from '../../streamline-icons/light/close-quote.svg';

export default builder('IconCloseQuoteLight', CloseQuote);
